import { render, staticRenderFns } from "./NextDelivery.vue?vue&type=template&id=7724d214&scoped=true&"
import script from "./NextDelivery.vue?vue&type=script&lang=js&"
export * from "./NextDelivery.vue?vue&type=script&lang=js&"
import style0 from "./NextDelivery.vue?vue&type=style&index=0&id=7724d214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7724d214",
  null
  
)

export default component.exports